import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface HomeHost {
  user_id: string;
  full_name: string | null;
  display_name: string | null;
  avatar_url: string | null;
  cover_image_url: string | null;
  professional_title: string | null;
  category_id: string | null;
  activities_count: number;
  bookings_count: number;
  avg_rating: number | null;
  reviews_count: number;
}

export function useHomeHosts(limit = 12) {
  return useQuery({
    queryKey: ['home-hosts', limit],
    queryFn: async (): Promise<HomeHost[]> => {
      const { data, error } = await (supabase as any).rpc('get_home_hosts', { _limit: limit });
      if (error) throw error;
      return (data || []).map((r: any) => ({
        user_id: r.user_id,
        full_name: r.full_name,
        display_name: r.display_name,
        avatar_url: r.avatar_url,
        cover_image_url: r.cover_image_url,
        professional_title: r.professional_title,
        category_id: r.category_id,
        activities_count: Number(r.activities_count) || 0,
        bookings_count: Number(r.bookings_count) || 0,
        avg_rating: r.avg_rating !== null ? Number(r.avg_rating) : null,
        reviews_count: Number(r.reviews_count) || 0,
      }));
    },
  });
}
